import { Dropdown } from "primereact/dropdown";
import { PossibleColumnProps, RowType } from "../types";
import { useSearchParams } from "react-router";

type FiltersDropdownsProps<TRow extends RowType> = {
  columns: PossibleColumnProps<TRow>[];
  dropdownConfigs: Record<string, { label: string; value: string | number }[]>;
};

function FiltersDropdowns<TRow extends RowType>({
  columns,
  dropdownConfigs,
}: FiltersDropdownsProps<TRow>) {
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <>
      {columns
        .filter((column) => column.enableFilter)
        .map((column) => {
          const uniqueValues =
            column.optionsKey && dropdownConfigs[column.optionsKey]
              ? (dropdownConfigs[column.optionsKey] as {
                  label: string;
                  value: string | number;
                }[])
              : [];

          const rawFilterValue = searchParams.get(column.field);
          const filterValue =
            uniqueValues.length > 0 && typeof uniqueValues[0].value === "number"
              ? rawFilterValue !== null
                ? Number(rawFilterValue)
                : null
              : rawFilterValue;

          const selectedLabel = uniqueValues.find(
            (option) => String(option.value) === String(filterValue),
          )?.label;

          return (
            <Dropdown
              key={column.field}
              value={filterValue}
              options={uniqueValues}
              optionValue="value"
              optionLabel="label"
              onChange={(e) =>
                setSearchParams((prev) => {
                  const params = new URLSearchParams(prev);

                  if (e.value) {
                    params.set(column.field, String(e.value));
                  } else {
                    params.delete(column.field);
                  }

                  return params;
                })
              }
              placeholder={selectedLabel || column.header}
              showClear={!!filterValue}
              filter
              filterPlaceholder="Szukaj..."
            />
          );
        })}
    </>
  );
}

export default FiltersDropdowns;
